// extracted by mini-css-extract-plugin
export default {"Skeleton":"styles_Skeleton__peeeN","load":"styles_load__icVc6"};